import PropTypes from 'prop-types';
import { useCallback } from 'react';
import { getData, getError } from 'conversations-async-data/async-data/operators/getters';
import { getFileName } from 'conversations-internal-schema/file-upload/operators/getFileName';
import { getFileSize } from 'conversations-internal-schema/file-upload/operators/getFileSize';
import { getUploadProgress, getFile } from 'conversations-internal-schema/file-upload/operators/fileUploadGetters';
import { fileIsImage } from 'conversations-internal-schema/file-upload/operators/fileIsImage';
import ImageAttachmentPreview from './ImageAttachmentPreview';
import AttachmentPreview from './AttachmentPreview';
// @ts-expect-error module not typed
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { reportError } from 'conversations-error-reporting/error-reporting/reportError';
import { LogLevel } from 'conversations-error-reporting/error-reporting/constants/LogLevel';
import { jsx as _jsx } from "react/jsx-runtime";
const UploadingFile = props => {
  const {
    asyncFileUpload,
    onRemove
  } = props;
  const fileUpload = getData(asyncFileUpload);
  if (!fileUpload) {
    reportError({
      error: new Error('null value for fileUpload'),
      componentData: {
        componentName: 'UploadingFile',
        props
      },
      level: LogLevel.error
    });
  }
  const file = fileUpload ? getFile(fileUpload) : undefined;
  const preview = file && fileIsImage(file) ? /*#__PURE__*/_jsx(ImageAttachmentPreview, {
    imageFile: file
  }) : undefined;
  const handleRemove = useCallback(() => {
    if (fileUpload) onRemove(fileUpload);
  }, [onRemove, fileUpload]);

  // fileUpload shouldn't ever be null since the asyncFileUpload is a required prop so these are coerced to not be null
  const name = getFileName(fileUpload);
  const size = getFileSize(fileUpload);
  const uploadProgress = getUploadProgress(fileUpload);
  return /*#__PURE__*/_jsx(AttachmentPreview, {
    name: name,
    size: size,
    error: getError(asyncFileUpload),
    uploadProgress: uploadProgress,
    removeAttachment: handleRemove,
    preview: preview
  });
};
UploadingFile.displayName = 'UploadingFile';
UploadingFile.propTypes = {
  asyncFileUpload: RecordPropType('AsyncData').isRequired,
  onRemove: PropTypes.func.isRequired
};
export default UploadingFile;